import { PublicClientApplication, BrowserCacheLocation } from '@azure/msal-browser';
import { microsoftSsoConfig } from './ssoConfig';

// Detect Safari browser
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const msalConfig = {
  auth: {
    clientId: microsoftSsoConfig.clientId,
    authority: microsoftSsoConfig.authority,
    redirectUri: microsoftSsoConfig.redirectUri,
  },
  cache: {
    cacheLocation: isSafari ? BrowserCacheLocation.SessionStorage : BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true, // Set to true for all browsers for better compatibility
    secureCookies: true, // Enable secure cookies
  },
};

export const loginRequest = {
  scopes: microsoftSsoConfig.scopes,
};

export const msalInstance = new PublicClientApplication(msalConfig);

